import React, { useContext, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "./About.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { LanguageContext } from "../../contexts/LanguageContext"; // Importer LanguageContext
import devImg from "../../assets/png/dev.png";
import { aboutData } from "../../data/aboutData"; 

function About() {
  const { theme } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext); // Utiliser useContext pour récupérer la langue

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Appliquer l'animation de l'image au scroll
    gsap.fromTo(
      "#about-img", // Cible de l'élément
      {
        x: 0,
        scale:0.9, // Position initiale (hors de l'écran)
        opacity: 0, // Opacité initiale
      },
      {
        x: 0, // Position finale
        opacity: 1, // Opacité finale
        scale: 1, // Échelle finale
        duration: 1, // Durée de l'animation
        scrollTrigger: {
          trigger: "#about-img", // Déclencheur (quand l'élément entre dans le viewport)
          start: "60% bottom", // Lorsque le haut de l'élément est à 80% du viewport
        },
      }
    );

    // Optionnel : Appliquer une animation à la description
    gsap.fromTo(
      "#about-description", 
      { opacity: 0 }, 
      {
        opacity: 1,
        duration: 2,
        scrollTrigger: {
          trigger: "#about-description",
          start: "bottom bottom",
        }
      }
    );
  }, []);

  // Récupérer les données de aboutData en fonction de la langue
  const title = aboutData.title[language]; 
  const description1 = aboutData.description[language];

  return (
    <div className="about" id="about">
      <div className="line-styling">
        <div className="style-circle" style={{ backgroundColor: theme.primary }}></div>
        <div className="style-circle" style={{ backgroundColor: theme.primary }}></div>
        <div className="style-line" style={{ backgroundColor: theme.primary }}></div>
      </div>
      <div className="about-header">
        <h2 style={{ color: theme.primary }}>{title}</h2> {/* Utiliser la langue active */}
      </div>
      <div className="about-body">
        <div className="about-img" id="about-img">
          <img src={devImg} alt="" />
        </div>
        <div className="about-description" id="about-description">
          <p style={{ color: theme.primary }}>
            {description1} {/* Utiliser la langue active pour la description */}
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;